import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { translate } from 'react-i18next';

class UpdateUserPasswordModal extends React.Component {

  onToggle = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    this.props.onToggle();
  };

  render() {
    const {
      t,
      currentPassword,
      password,
      passwordRepeated,
      onCurrentPassword,
      onPassword,
      onPasswordRepeated,
      disabled,
      onSave,
      onCancel,
      canSave,
      isOpen
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value: value || '',
      onChange: (event) => fn(event.target.value)
    });
    return (
      <Modal isOpen={isOpen} toggle={disabled ? (() => {}) : this.onToggle} size="md">
        <ModalHeader toggle={disabled ? (() => {}) : this.onToggle}>{t('updatePassword.title')}</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="updatePassword_currentPassword">{t('updatePassword.currentPasswordLabel')}</Label>
                <Input
                  type="password"
                  name="updatePassword_currentPassword"
                  id="updatePassword_currentPassword"
                  placeholder={t('updatePassword.currentPasswordPlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(currentPassword, onCurrentPassword)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="updatePassword_password">{t('updatePassword.passwordLabel')}</Label>
                <Input
                  type="password"
                  name="updatePassword_password"
                  id="updatePassword_password"
                  placeholder={t('updatePassword.passwordPlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(password, onPassword)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="updatePassword_passwordRepeated">{t('updatePassword.passwordRepeatedLabel')}</Label>
                <Input
                  type="password"
                  name="updatePassword_passwordRepeated"
                  id="updatePassword_passwordRepeated"
                  placeholder={t('updatePassword.passwordRepeatedPlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(passwordRepeated, onPasswordRepeated)}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="d-flex flex-row justify-content-end align-items-center">
          <div>
            <Button
              color="primary"
              size="sm"
              disabled={!canSave || disabled}
              onClick={onSave}
            >
              {t('updatePassword.saveAction')}
            </Button>
            {' '}
            <Button
              color="danger"
              size="sm"
              disabled={disabled}
              onClick={onCancel}
            >
              {t('updatePassword.cancelAction')}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

UpdateUserPasswordModal.propTypes = {
  currentPassword: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  passwordRepeated: PropTypes.string.isRequired,
  onCurrentPassword: PropTypes.func.isRequired,
  onPassword: PropTypes.func.isRequired,
  onPasswordRepeated: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default translate(['user'], { wait: true })(UpdateUserPasswordModal);


// WEBPACK FOOTER //
// ./src/views/user/update-password-modal.js